"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogListenerConsole = void 0;
var ILogMessage_1 = require("./ILogMessage");
exports.LogListenerConsole = {
    log: function (message) {
        switch (message.level) {
            case ILogMessage_1.LogLevel.ERROR:
                console.error(message.message, message.error);
                break;
            case ILogMessage_1.LogLevel.WARNING:
                console.warn(message.message, message.error);
                break;
            case ILogMessage_1.LogLevel.INFO:
                console.info(message.message);
                break;
            default:
                console.log(message.message);
                break;
        }
    },
};
//# sourceMappingURL=LogListenerConsole.js.map